export enum AssessmentOutcomesView {
  ASSESSMENT_CLASSIFICATION = 'ASSESSMENT_CLASSIFICATION',
  DYSLEXIA_RISK = 'DYSLEXIA_RISK',
  SUMMATIVE_PREDICTIONS = 'SUMMATIVE_PREDICTIONS',
  ASSESSMENT_GROWTH = 'ASSESSMENT_GROWTH',
}
